<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AVzz">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="1. Psalm 19:14">
<div class="image"><img alt="" role="presentation" src="images/6.jpg"/>
</div>
<h1 class="h1_4" id="pARDy"><a href="#/contenttoc#ba_03" id="ab_03"><b>1<br/> <img alt="" role="presentation" src="images/5.jpg"/><br/> <i>Psalm 19:14</i></b></a></h1>
<p class="center3" id="pz8-2">Let the <span class="cen3a"><b><em>words</em></b></span> of<br/> my mouth and the<br/><span class="cen3a"><b><em>meditation</em></b></span> of my<br/> heart be acceptable<br/> in Your sight, O Lord,<br/> my <b><span class="cen3a"><em>strength</em></span></b> and<br/> my Redeemer.</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter03.vue?35e5bb02